import TextField from '@mui/material/TextField';
import SearchIcon from '@mui/icons-material/Search';
import InputAdornment from '@mui/material/InputAdornment';
import Box from '@mui/material/Box';
import { Ref } from 'react';
import { useTheme } from '@mui/material';

export type SearchBarProps = {
  queryHandler: () => Promise<void>;
  inputRef: Ref<HTMLInputElement>;
};
export default function SearchBar({ queryHandler, inputRef }: SearchBarProps) {
  const theme = useTheme();
  const background = theme.palette.background.elevationSolid[8];
  return (
    <Box
      component="form"
      noValidate
      autoComplete="off"
      onSubmit={queryHandler}
      sx={{
        '&:hover fieldset': {
          border: 'none',
        },
        '& .MuiInputBase-root': {
          backgroundImage: 'none !important',
          borderRadius: 10,
        },
        border: 'double 1.5px transparent',
        borderRadius: '40px',
        backgroundImage: `linear-gradient(${background}, ${background}), linear-gradient(180deg, #4DC8FF 0%, #0064E9 100%)`,
        backgroundOrigin: 'border-box',
        backgroundClip: 'content-box, border-box',
        height: '40px',
        zIndex: 2,
        flexGrow: 1,
        boxShadow: theme.shadowsHard.primaryElevation1,
      }}
    >
      <TextField
        id="outlined-basic"
        placeholder="Search..."
        variant="outlined"
        size="small"
        inputRef={inputRef}
        sx={{
          '& .MuiOutlinedInput-root': {
            '& > fieldset': {
              border: 'none',
            },
            boxShadow: 'none',
          },
          border: 'none',
          background: 'transparent',
          backgroundImage: 'none !important',
          width: '100%',
        }}
        InputProps={{
          startAdornment: (
            <InputAdornment position="start">
              <SearchIcon sx={{ color: 'white' }} />
            </InputAdornment>
          ),
        }}
      />
    </Box>
  );
}
